import { createApp } from 'vue'
import DeliveryAddress from './DeliveryAddress'

const el = '.kb-component--delivery-address'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DeliveryAddressDOM) => {
            const component = createApp(DeliveryAddress).use(Store)
            component.mount(DeliveryAddressDOM)
        })
    }
}
